<template>
  <v-sheet>
    <v-sheet class="d-flex flex-column my-10">
      <v-row
        v-for="(item, index) in contItems"
        :key="index"
        align="center"
        justify="center"
        class="flex-column flex-sm-row"
      >
        <v-col cols="12" sm="6" lg="4" xl="2">
          <v-sheet
            class="ma-3 pa-5 rounded-pill"
            v-if="item.header"
            color="green"
          >
            <strong>{{ item.header }}</strong>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" lg="4" xl="2">
          <v-sheet class="ma-3 pa-5" v-if="item.content">
            <div v-html="item.content" class="text-center"></div>
            <!--link:urlのパラメータがあるときだけ出る-->
            <div class="text-center ma-3">
              <v-btn
                v-if="item.link"
                text
                :href="item.link"
                target="_blank"
                variant="tonal"
                class="pa-2"
                color="green-darken-3"
                >webサイト</v-btn
              >
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-sheet>
  </v-sheet>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
        contItems: [
          {
            header: "開催予定日",
            content: "2023年8月27日日曜日",
          },

          {
            header: "イベント開催時間",
            content: "11時～17時",
          },
          {
            header: "入場料",
            content: "1時間300円（THE CAFE店内でフリードリンク付）",
          },

          {
            header: "メイン会場/受付",
            content: "「THE CAFE」",
            link: "https://tabaco.biz/",
          },
          {
            header: "サブ会場",
            content: "「昭和ブックカフェ」",
            link: "https://shimbashidaisuki.com/",
          },

          {
            header: "会場住所",
            content: "〒105-0004 東京都港区新橋2-16-1 ニュー新橋ビル3F",
          },
        ],
      };
    },
  };
</script>
<!-- <style scoped>
  .contenttext {
    text-align: center;
  }
</style> -->
